// Safe storage handler
window.safeStorage = {
  getItem: function(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      console.warn('localStorage access denied:', e);
      return null;
    }
  },
  setItem: function(key, value) {
    try {
      localStorage.setItem(key, value);
      return true;
    } catch (e) {
      console.warn('localStorage access denied:', e);
      return false;
    }
  }
};
